import { getDictPhrase } from "../../../common";
export const getBetTitleComboBetProps = (bet, state) => {
    const comboTypePhrase = `ComboNames_${bet.selections.length}`;
    return {
        name: getDictPhrase(state.dict, comboTypePhrase) + (bet.isEachWay
            ? ` ${getDictPhrase(state.dict, "EachWay")}`
            : ""),
        odds: bet.displayOdds
    };
};
//# sourceMappingURL=getBetTitleComboBetProps.js.map